import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function SectionEight({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Section 8" />
          </Col>
          <Col span={24}>
            <p>
              If urgent or life threatening make sure and have work completed in
              the time allotted.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              You MUST then notify section 8 and send them a copy of the invoice
              by fax prior to the deadline.
            </h3>
          </Col>
          <Col span={24}>
            <p>
              For typical section 8 work order make sure and assign a vendor for
              all work. generally the work will be over the minimum so be sure
              owner is aware of work and amount however the repairs will not be
              optional.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="blue-heading">
              Ensure all work is completed RIGHT AWAY and verify with vendor and
              tenant that work is complete. request pictures if needed.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              Notify section 8 that the work is completed and verify date of
              follow up inspection
            </h3>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default SectionEight;
